<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>
        <v-form>
            <div class="grid">
                <FormInputText fieldName="ftp_host"
                               label="Host address"
                               size="4"
                               v-model:field="ftpData.ftp_host" />

                <FormInputText fieldName="ftp_username"
                               label="User name"
                               size="4"
                               v-model:field="ftpData.ftp_username" />

                <FormPassword fieldName="ftp_password"
                              label="Password"
                              size="4"
                              v-model:field="ftpData.ftp_password" />

                <FormInputText fieldName="ftp_path"
                               label="FTP server path"
                               size="6"
                               v-model:field="ftpData.ftp_path" />

                <FormInputNumber fieldName="ftp_port"
                                 label="FTP port"
                                 size="2"
                                 v-model:field="ftpData.ftp_port" />

                <FormInputToggleButton fieldName="ftp_is_passive"
                                       label="Is passive connection?"
                                       size="4"
                                       v-model:field="ftpData.ftp_is_passive" />
            </div>
            <div class="grid"
                 style="margin-top:30px">
                <Button severity="success"
                        style="margin:0 8px"
                        @click="startPackAndSend">
                    <i class="fa-solid fa-plus"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Ok') }}
                </Button>
                <Button severity="secondary"
                        style="margin:0 8px"
                        @click="cancel">
                    <i class="fa-solid fa-ban"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Cancel') }}
                </Button>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormPassword from '@crud/FormPassword.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import { __, screenMessage, getFromRoute, getTimeouts } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const isPackDbAndSendFormOpen = defineModel('isPackDbAndSendFormOpen', { type: Boolean, default: false })
const isLoading = ref(false)
const ftpData = ref({
    ftp_host: 'ftp.transkom.net.pl',
    ftp_username: 'akwedukt@transkom.net.pl',
    ftp_password: 'Akwedukt123#345',
    ftp_path: '',
    ftp_port: 21,
    ftp_is_passive: true
})

// -----------------------------------------------------

const cancel = () => {
    isPackDbAndSendFormOpen.value = false
}
// -----------------------------------------------------

const startPackAndSend = async () => {
    const data = {
        ftp_host: ftpData.value.ftp_host,
        ftp_username: ftpData.value.ftp_username,
        ftp_password: ftpData.value.ftp_password,
        ftp_path: ftpData.value.ftp_path,
        ftp_port: ftpData.value.ftp_port,
        ftp_is_passive: ftpData.value.ftp_is_passive
    }

    isLoading.value = true
    try {
        const response = await getFromRoute('database-pack-send', data, 'post')
        if (response && response.status === 'success') {
            screenMessage({ message: response.message, title: __('Information'), type: 'info', position: 'center', timeout: 10 })
        } else if (response && response.status === 'error') {
            screenMessage({ message: response.message, title: __('Error'), type: 'error', position: 'center', timeout: 10 })
        } else {
            screenMessage({ message: __('Unexpected server response'), title: __('Error'), type: 'error', position: 'center', timeout: 10 })
        }
    } catch (error) {
        // ✅ Obsługa błędów sieciowych / wyjątków
        const msg = error?.response?.data?.message || error?.message || __('Failed to connect to the server')
        screenMessage({ message: msg, title: __('Error'), type: 'error', position: 'center', timeout: 10 })
    } finally {
        isLoading.value = false
        isPackDbAndSendFormOpen.value = false
    }
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
